module.exports = __webpack_public_path__ + "static/media/sexpirikos-bg.3a99f366.jpg";